import { patchRequest } from '@/core';
import { cargoCarrierTypes } from '@/requests';

export async function updateCargoCarrierTypeRequest(id, patch) {
	let url = cargoCarrierTypes.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}
